import { reactive, ref, toRefs } from 'vue'
import { defineStore } from 'pinia'
import { setCookie } from '@/utils/cookie'
import { CommonType } from '@/interface'

interface UserInfo {
  appName: string
  token: string
  admingInfo: CommonType
  firstLogin: string | null
}
export const userPinia = defineStore(
  'userPinia',
  () => {
    const state = reactive<UserInfo>({
      appName: '',
      token: '',
      admingInfo: {},
      firstLogin: null
    })
    // pinia 构建成功后，正式环境下WEB_URL会自动变为'/'(ref或者reactive模式)
    const WEB_URL = import.meta.env.VITE_WEB_URL
    const userInfo = ref<CommonType>({
      nsrsbh: ''
    })
    function login(data: string) {
      state.token = data
      sessionStorage.setItem('access-engine-token', data)
    }
    function logout() {
      state.appName = ''
      state.token = ''
      state.admingInfo = {}
      state.firstLogin = null
      sessionStorage.clear()
      sessionStorage.removeItem('access-engine-token')
    }
    function setUserInfo(data: CommonType) {
      userInfo.value = data
    }
    function setAdmingInfo(data: CommonType) {
      state.admingInfo = data
    }
    function setFirstLogin(data: string | null) {
      state.firstLogin = data
      data && setCookie('first-login', data)
    }
    return { ...toRefs(state), userInfo, login, logout, setUserInfo, WEB_URL, setAdmingInfo, setFirstLogin }
  },
  {
    persist: {
      enabled: true
    }
  }
)
